module.exports = __webpack_public_path__ + "img/przelewy24.a8087d5.png";